var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 282,
    viewBox: "0 0 442 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19904)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.236328,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "#FD7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.66016,
    y: 368.451,
    width: 621.724,
    height: 281.452,
    transform: "rotate(-45.0715 3.66016 368.451)",
    fill: "#FFD707"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.6992,
    y: -23.584,
    width: 621.724,
    height: 281.452,
    transform: "rotate(28.3141 -40.6992 -23.584)",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19904"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.236328,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/card5.d17975483c31631d55f09d88a067141c.svg";
export { ForwardRef as ReactComponent };